import { cn } from "@simpro/ui";
import { ArrowRight } from "lucide-react";

/**
 * The arrow in its own circle at the end of a pill (design note salon-booking-organic-wellness.md
 * section 6). On the green pill (`on="ink"`) it is the board's pale sage disc with a green arrow; on the
 * accent pill it is a disc of the label's colour with the accent's arrow. The pill takes `pill.arrow` so
 * the disc sits a few pixels in from its rounded end, and `group` so the arrow nudges forward on hover.
 * Decorative: the pill's label names the action.
 */
export function ArrowDisc({ className, on = "accent" }: { className?: string; on?: "accent" | "ink" }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "grid size-11 shrink-0 place-items-center rounded-full",
        on === "ink" ? "bg-sage-tint text-heading" : "bg-on-accent text-accent-500",
        className,
      )}
    >
      <ArrowRight className="size-[18px] transition-transform duration-300 group-hover:translate-x-0.5" />
    </span>
  );
}
